import Typography, { TypographyProps } from '@mui/material/Typography'

function CardDescription({ height, style, ...rest }: TypographyProps) {
  return <Typography align="center" style={{ height, ...style }} {...rest} />
}

export default CardDescription
